import { createAsyncAction } from "../actionCreators";
import { API, APIResultList } from "@thenounproject/lingo-core";

type Args = {
  uuids: string[];
};

type BatchProcessAssetsResult = APIResultList<"assets", string>;

const [useBatchProcessAssets, batchProcessAssets] = createAsyncAction(
  "assets/batchProcessAssets",
  async ({ uuids }: Args) => {
    const res = await API.call<BatchProcessAssetsResult>({
      endpoint: `assets/process`,
      method: "PUT",
      data: { uuids },
    });
    return res;
  }
);

export default useBatchProcessAssets;
export { batchProcessAssets };
